import { useRouter, useRoute } from 'vue-router/composables';

export function useNavigateToRoute() {
    const router = useRouter();
    const route = useRoute();

    function navigateToRoute(targetRoute) {
        if (route.path === targetRoute.path && JSON.stringify(route.query) === JSON.stringify(targetRoute.query)) {
            // Force reload by adding a unique query parameter
            targetRoute.query = { ...targetRoute.query, reload: Date.now() };
        }
        router.push(targetRoute).catch(() => { });
    }

    return { navigateToRoute }
}